import classNames from 'classnames';
import { useLocation, Link } from 'react-router-dom';

import { Icon } from './Icon';

interface SideNavIconItemProps {
  icon: string;
  url: string;
  title: string;
}

export const SideNavIconItem = ({ icon, url, title }: SideNavIconItemProps): JSX.Element => {
  const { pathname } = useLocation();
  const isItemActive = url === pathname;

  return (
    <Link
      to={url}
      className={classNames(
        'flex mb-4 flex-shrink-0 hover:bg-primary-1.0 py-2 px-1 rounded no-underline relative',
        isItemActive ? 'bg-primary-1.0 font-bold' : ''
      )}
      data-testid={`nav-${title}`}
      id={title}
    >
      <Icon name={icon} className="m-auto text-xl text-white-1.0" />
    </Link>
  );
};
